
export const formatDate = (date: Date | string | null): string => {
  if (!date) return "-";
  const d = typeof date === "string" ? new Date(date) : date;
  return new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(d);
};

export const formatShortDate = (date: Date | string | null): string => {
  if (!date) return "-";
  const d = typeof date === "string" ? new Date(date) : date;
  return new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  }).format(d);
};

export const formatNumber = (value: number | null): string => {
  if (value === null) return "-";
  return value.toLocaleString();
};

export const formatCost = (amount: string, currency: string): string => {
  const num = parseFloat(amount);
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 6,
  }).format(num);
};

export const formatCurrency = (
  value: number | string,
  currency: string,
): string => {
  const num = typeof value === "string" ? parseFloat(value) : value;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
};

export const getCostPercent = (cost: string, total: number): number => {
  if (total === 0) return 0;
  return (parseFloat(cost) / total) * 100;
};
